<script>
  export default {
    created() {
      this.updateBreadcrumb()
    },
    data() {
      return {
        breadcrumbs: []
      }
    },
    methods: {
      updateBreadcrumb() {
        this.breadcrumbs = this.$route.meta.breadcrumbs
      }
    },
    name: 'BreadcrumbMixin',
    watch: {
      '$route.meta'() {
        this.updateBreadcrumb()
      }
    }
  }
</script>
